<template>
  <div id="login-selection">
    <div class="login-selection-container">
      <LeftView v-bind:coverImage="coverImage" />
      <div class="right-view">
        <have-account v-bind:haveAccountData="haveAccountData" />
        <onboarding-form
          class="reset-form"
          v-bind:errorExists="errorExists"
          v-bind:formData="formData"
          v-on:changeInput="handleChange"
          v-bind:errors="errors"
          v-on:setErrorExists="setErrorExists"
          v-bind:formTitleText="formTitleText"
          v-bind:formSubtext="formSubtext"
          v-bind:formFields="formFields"
          v-bind:hintText="hintText"
          v-bind:baseLink="baseLink"
          v-bind:buttonText="buttonText"
          v-on:userData="userData"
          :toggle="toggle"
          v-on:toggleAnimation="lockChild"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LeftView from '../components/SignupSelection/LeftView.vue';
import coverImage from '../assets/images/account-recovery-cover-image.jpg';
import HaveAccount from '../components/body/HaveAccount.vue';
import OnboardingForm from '../components/body/OnboardingForm.vue';

export default {
  name: 'ResetPassword',
  components: {
    LeftView,
    HaveAccount,
    OnboardingForm,
  },
  data() {
    return {
      formData: {
        password: '',
        confirmPassword: ''
      },
      errors: {
        companyNameError: '',
        firstNameError: '',
        lastNameError: '',
        emailError: '',
        phoneError: '',
        passwordError: '',
        confirmPasswordError: ''
      },
      errorExists: '',
      toggle: false,
      haveAccountData: {
        haveAccountTitle: '',
        haveAccountButtonText: '',
        haveAccountLink: '',
      },
      formTitleText: 'Reset Password',
      formSubtext: 'Please enter your new password below.',
      formFields: [
        { name: 'password', placeholder: 'New Password', type: 'password', errorName:'passwordError' },
        { name: 'confirmPassword', placeholder: 'Confirm Password', type: 'password', errorName:'confirmPasswordError' },
      ],
      baseLink: { link: '/login', text: 'Back to Login' },
      hintText:
          'Hint: Enter a combination of letters and numbers of not less than eight characters',

      buttonText: 'Reset',
      coverImage: coverImage,
    };
  },
  methods: {
    setErrorExists(value){
      this.errorExists = value;
    },

    handleChange(data){
      switch(data.name){
        case 'password':
          this.formData.password = data.value;
          break;
        case 'confirmPassword':
          this.formData.confirmPassword = data.value;
          break;
      }
    },
    permitChild: function () {
      this.toggle = true;
    },
    lockChild: function () {
      this.toggle = false;
    },
    userData(data) {
      let token = this.$route.query.token;
      let password = data.password;
      let updatedData = { password, token };
      this.$store
          .dispatch('resetPassword', updatedData)
          .then((res) => {
            this.permitChild();
            if (res.response) {
              this.$toastr.success(res.response.message, 'Success');
              setTimeout(() => this.$router.push('/login'), 1000);
            } else {
              res.error.error
                ? this.$toastr.error(res.error.error, 'Password Reset Failed')
                : this.$toastr.error(
                    'Couldn\'t establish connection',
                    res.error.message
                );
            }
          })
          .catch((error) => {
            throw error;
          });
    },
  },
};
</script>
<style scoped>
  .login-selection-container {
    display: flex;
  }
  @media only screen and (min-width: 991px) {
    .reset-form {
      padding-top: 10%;
    }
  }
</style>
